import axios from 'axios';
import { API_BASE } from '../config';

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lenmo_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginPage = window.location.pathname.toLowerCase().includes('login');
      if (!isLoginPage) {
        localStorage.removeItem('lenmo_token');
        localStorage.removeItem('lenmo_user');
        const isMember = window.location.pathname.toLowerCase().includes('member');
        window.location.href = isMember ? '/memberLogin' : '/adminLogin';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
